import React, { Component } from 'react'
import ImportExportDynamicInventoryPolicyComponent from 'components/import-export-json/import-export-dynamic-inventory-policy'
import intl from 'react-intl-universal'
import moment from 'moment'
import { downloadFile } from 'utils/custom-functions'
import * as services from './importer-exporter-dynamic-inventory-policy.service'

interface Props {
  handleClose: () => void
  open: boolean
}

class ImportExportDynamicInventoryPolicy extends Component<Props> {
  downloadFile = async (): Promise<void> => {
    try {
      const data = await services.downloadDynamicInventoryPolicy()
      const datafile = moment(new Date()).format('YYYYMMDD_HHmmss')
      downloadFile(`${intl.get('commons.dynamicInventoryPolicyFile')}_${datafile}.csv`, 'csv', data)
    } catch (e) {
      console.error('Error downloading file:', e)
    }
  }

  downloadTemplate = async (): Promise<void> => {
    try {
      const data = await services.downloadDynamicInventoryPolicyTemplate()
      const datafile = moment(new Date()).format('YYYYMMDD_HHmmss')
      downloadFile(`${intl.get('commons.dynamicInventoryPolicyTemplate')}_${datafile}.csv`, 'csv', data)
    } catch (e) {
      console.error('Error downloading template:', e)
    }
  }

  render(): JSX.Element {
    const { open, handleClose } = this.props

    return (
      <ImportExportDynamicInventoryPolicyComponent
        open={open}
        title={intl.get('exportImportModal.dynamicInventoryPolicy.title')}
        contextModal="dynamicInventoryPolicy"
        handleClose={handleClose}
        downloadArquivo={this.downloadFile}
        downloadModelo={this.downloadTemplate}
      />
    )
  }
}

export default ImportExportDynamicInventoryPolicy
